import * as CONST from './const'

/**
 * Get all missions by cityId
 *
 * @param cityId
 * @returns {{type, cityId}}
 */
export const getMissionsByCityId = (cityId, data) => ({
  type: CONST.GET_MISSIONS_BY_CITY_ID,
  cityId,
  data,
})

/**
 * Get missions
 *
 * @returns {{type}}
 */
export const getCampaignMissions = campaignId => ({
  type: CONST.GET_CAMPAIGN_MISSIONS,
  campaignId,
})

/**
 * Get mission by id
 * @returns {{type}}
 */
export const getMissionById = (missionId, callbacks) => ({
  type: CONST.GET_MISSION_BY_ID,
  missionId,
  callbacks,
})

export const getMissionByIdGraphQL = missionId => ({
  type: CONST.GET_MISSION_BY_ID_GRAPH_QL,
  payload: { missionId },
})

/**
 * Update mission
 */
export const updateMission = mission => ({
  type: CONST.UPDATE_MISSION,
  payload: { mission },
})

/**
 * Update mission
 *
 * @param missionId
 * @param payload
 * @returns {{type, missionId: *, payload: *}}
 */
export const createMissionPickup = (missionId, callbacks, payload) => ({
  type: CONST.CREATE_MISSION_PICKUP,
  missionId,
  callbacks,
  payload,
})

/**
 * Apply filters for missions to master schedule in campaign
 *
 * @param filters
 */
export const applyMasterScheduleFilters = filters => ({
  type: CONST.APPLY_FILTERS,
  filterType: 'masterSchedule',
  filters,
})

/**
 * Get All the missions scheduled for pickup in the specified city
 *
 * @param cityId
 */
export const getScheduledPickups = cityId => ({
  type: CONST.FETCH_SCHEDULED_PICKUPS,
  cityId,
})

/**
 * Update missions in parallel
 *
 * @param data
 * @param callbacks
 * @returns {{type, data: *, callbacks: *}}
 */
export const updateMissionsAll = (data, callbacks) => ({
  type: CONST.UPDATE_MISSIONS_ALL,
  data,
  callbacks,
})

/**
 * Set the filters to use on mission list
 *
 * @param filters
 * @returns {{type}}
 */
export const setMissionsListFilter = filters => ({
  type: CONST.SET_MISSIONS_LIST_FILTER,
  filters,
})

/**
 * Unbook a mission
 *
 * @param missionId
 * @param callbacks
 * @returns {{type, dispatchAction: *, dispatchProps: *}}
 */
export const unbookMissionById = payload => ({
  type: CONST.UNBOOK_MISSION_BY_ID,
  payload,
})

/**
 * Set missions mission type filter
 *
 * @param missionsTypeFilter
 * @returns {{type, missionsTypeFilter: *}}
 */
export const setMissionsTypeFilter = missionsTypeFilter => ({
  type: CONST.SET_MISSIONS_TYPE_FILTER,
  missionsTypeFilter:
    CONST.MISSIONS_TYPE_FILTER_OPTIONS.indexOf(missionsTypeFilter) > -1
      ? missionsTypeFilter
      : CONST.MISSIONS_TYPE_FILTER_OPTIONS[0],
})

/**
 * Set missions day period filter
 *
 * @param missionsDayPeriodFilter
 * @returns {{type, missionsDayPeriodFilter: *}}
 */
export const setMissionsDayPeriodFilter = missionsDayPeriodFilter => ({
  type: CONST.SET_MISSIONS_DAY_PERIOD_FILTER,
  missionsDayPeriodFilter:
    CONST.MISSIONS_DAY_PERIOD_FILTER_OPTIONS.indexOf(missionsDayPeriodFilter) >
    -1
      ? missionsDayPeriodFilter
      : CONST.MISSIONS_DAY_PERIOD_FILTER_OPTIONS[0],
})

/**
 * Set missions status filter
 *
 * @param missionsStatusFilter
 * @returns {{type, missionsStatusFilter: *}}
 */
export const setMissionsStatusFilter = missionsStatusFilter => ({
  type: CONST.SET_MISSIONS_STATUS_FILTER,
  missionsStatusFilter:
    CONST.MISSIONS_STATUS_FILTER_OPTIONS.indexOf(missionsStatusFilter) > -1
      ? missionsStatusFilter
      : CONST.MISSIONS_STATUS_FILTER_OPTIONS[0],
})

/**
 * Set roster view missions sort by
 *
 * @param sortBy
 * @returns {{type, sortBy: *}}
 */
export const setRosterViewMissionsSortBy = sortBy => ({
  type: CONST.SET_ROSTER_VIEW_MISSIONS_SORT_BY,
  sortBy,
})

/**
 * Create missions
 * @param {Array<Mission>} missions
 */
export const createMissions = missions => ({
  type: CONST.CREATE_MISSIONS,
  payload: { missions },
})

export const deleteMissions = payload => ({
  type: CONST.DELETE_MISSIONS,
  payload,
})

export const publishMissions = missions => ({
  type: CONST.PUBLISH_MISSIONS,
  payload: { missions },
})
